/*
 * Author: zhanghj
 * Date: 2020-09-08 10:16:08
 * LastEditors: zhanghj
 * LastEditTime: 2021-01-07 14:19:29
*/
import Home from './home';
import './index.less';

export default function() {
  return <Home />;
}
